module.exports = "#visCaseProfileBar{border-radius:40px}\n"